import { LoadState } from "../../constants/enums";

export interface ICallContext {
  call_ref: string;
  link_status: "PENDING" | "LINKED" | "EXPIRED" | "FAILED";
  uniqueid: string | null;
  error_message?: string | null;
}

// A CRM-screen click sets this just before the user dials. The SoftphoneWidget
// (or any other code path that fires `sipClient.call()`) reads it, POSTs the
// linkage row to /mirtapbx/calls/context, and clears it. The scope is
// explicit — the resulting CDR links to these ids whether or not the dialled
// phone number resolves to anyone in the DB.
export interface IPendingCallScope {
  customer_id?: number | null;
  customer_policy_id?: number | null;
  lead_id?: string | null;
  // Milliseconds since epoch. Used to drop a stale scope the user set but
  // never followed through on (default TTL 60 s).
  set_at: number;
}

export interface IMirtapbxCallContextState {
  current: ICallContext | null;
  createLoading: LoadState;
  pollStatus: "IDLE" | "PENDING" | "LINKED" | "EXPIRED" | "FAILED";
  error: string | null;
  // Set by <CallButton> on CRM screens; consumed by the SoftphoneWidget on the
  // next `sipClient.call()`. Null when the next dial has no CRM context (e.g.
  // the user types a number into the softphone dial pad).
  pendingScope: IPendingCallScope | null;
}

export const initialMirtapbxCallContextState: IMirtapbxCallContextState = {
  current: null,
  createLoading: LoadState.NotLoaded,
  pollStatus: "IDLE",
  error: null,
  pendingScope: null,
};
